import axios from 'axios';
import { API, authHeaders } from './client';

export const getContacts = (token, params) =>
  axios.get(`${API}/contacts`, { params, ...authHeaders(token) }).then(r => r.data);

export const createContact = (token, data) =>
  axios.post(`${API}/contacts`, data, authHeaders(token)).then(r => r.data);

export const deleteContact = (token, id) =>
  axios.delete(`${API}/contacts/${id}`, authHeaders(token)).then(r => r.data);

export const sendEmailToContact = (token, id, subject, message, original_message = '') =>
  axios.post(`${API}/contacts/${id}/send-email`, null, {
    params: { subject, message, original_message },
    ...authHeaders(token)
  }).then(r => r.data);

// Fetch a DB-stored attachment as a Blob (admin auth), for inline preview / download
export const getAttachmentBlob = (token, attId) =>
  axios.get(`${API}/contacts/attachment/${attId}`, { responseType: 'blob', ...authHeaders(token) })
    .then(r => r.data);
